import { contactUpdateDescription as description } from './description';
import { updateContact as execute } from './execute';

export { description, execute };
